<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel" :width="700">
      <h3 slot="header" class="modal-header">企业续约-选择房间</h3>
      <div class="flex">
        <div class="roomlist">
          <h4 class="mb8">房间列表</h4>
          <ul>
            <li v-for="(item,index) in canSelect"
                :class="['ivu-btn',{'btn-primary2':item.isSelected}]"
                :key="'keyA'+index"
                @click.stop="selectItem(item)"
            >{{item.stockNumber}}
            </li>
            <br>
            <li class="item ivu-btn disabled "
                v-for="(item,index) in cannotSelect"
                :key="'keyC'+index"
            >{{item.stockNumber}}</li>
          </ul>
        </div>
        <div class="checklist">
          <h4 class="mb8">已选列表</h4>
          <ul>
            <li v-for="(item,index) in checkList" class="ivu-btn btn-primary2"
                :key="'keyB'+index"
                @click.stop="selectItem(item)"
            >{{item.stockNumber}}
            </li>
          </ul>
        </div>
      </div>
      <create-business-contract :n="n1" :projectFid="projectFid"
                                :createContractDataOri="createContractData"
                                :contractFid="contractFid"
                                :conEndDateOri="Number(conEndDate)"
                                :parentContractFid="parentContractFid"
                                v-if="createContractData && conEndDate"
                                :roomIds="roomIds"
                                :roomsCount="checkList.length"
                                :list="list"
                                @done="done"

      ></create-business-contract>
    </Modal>
  </div>
</template>
<script>
  import {renewstockinfo, enterprisecontractroomCanRent} from "../../../../api/contractList";
  import CreateBusinessContract from './CreateBusinessContract'

  export default {
    name: "",
    components: {
      CreateBusinessContract
    },
    props: {
      conEndDate:[String,Number],
      contractFid:{
        type: String,
        default: ''
      },

      n: {
        type: Number,
        default: 0
      },
      // contractFid: {
      //   type: String,
      //   default: ''
      // },
      projectFid: {
        type: String,
        default: ''
      },
      parentContractFid: {
        type: String,
        default: ''
      },
    },
    watch: {
      n() {
        this.data=[]
        this.renewstockinfo()
        this.isShow = true
      }
    },
    data() {
      return {
        createContractData: null,
        n1: 0,
        loading: true,
        isShow: false,
        data: []
      }
    },
    computed: {
      list(){
        let ret=[]
        this.checkList.forEach(ele=>{
          ret.push({
            contractFid:ele.contractFid,
            stockFid:ele.stockFid
          })
        })
        return ret
      },
      contractFids(){
        let ret=[]
        this.checkList.forEach(ele=>{
          ret.push(ele.contractFid)
        })
        return ret.join(',')
      },
      roomIds(){
        let ret=[]
        this.checkList.forEach(ele=>{
          ret.push(ele.stockFid)
        })
        return ret.join(',')
      },
      canSelect(){
        return this.data.filter(ele=>{
          return  ele.isRenew===0
        })
      },
      cannotSelect(){
        return this.data.filter(ele=>{
          return  ele.isRenew===1
        })
      },
      checkList() {
        return this.canSelect.filter(ele => {
          return ele.isSelected
        })
      },
      checkRoomNums() {
        let ret = []
        this.checkList.forEach(ele => {
          ret.push(ele.stockNumber)
        })
        return ret.join(',')
      },
      checkRoomIds() {
        let ret = []
        this.checkList.forEach(ele => {
          ret.push(ele.stockFid)
        })
        return ret.join(',')
      },
    },
    methods: {
      done(){
        this.$emit('done')
        this.isShow=false
      },
      renewstockinfo() {
        let params = {
          parentContractFid: this.parentContractFid,
          reNewOrUnRentApply:0

        }
        renewstockinfo(params).then(res => {
          if(!res.data){
            this.$Message.info('不存在可选房间')
            return
          }
          res.data.forEach(ele => {
            ele['isSelected'] = false
          })
          this.data = res.data
        }).catch(error => {})
      },
      enterprisecontractroomCanRent() {
        let params = {
          roomIds: this.checkRoomIds,
          projectFid: this.projectFid,
          contractFids:this.contractFids
        }
        enterprisecontractroomCanRent(params).then(res => {
          if(res.data.roomCanRent.canRent===false){
            this.$Message.info(res.data.roomCanRent.message)
          }
          else {
            this.createContractData = res.data
            this.n1++
          }
        }).catch(error => {})
        this.changeLoading()
      },
      selectItem(item) {
        item.isSelected = !item.isSelected
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (this.checkRoomIds == '') {
          this.$Message.info('请选择房间')
          this.changeLoading()
          return
        }
        let params = {
          roomIds: this.checkRoomIds,
          projectFid: this.projectFid,
          contractFids:this.contractFids
        }
        enterprisecontractroomCanRent(params).then(res => {
          if(res.data.roomCanRent.canRent===false){
            this.$Message.info(res.data.roomCanRent.message)
          }
          else {
            this.createContractData = res.data
            this.$nextTick(()=>{
              this.n1++
            })
          }
          this.changeLoading()
        }).catch(error => {})
      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .flex {
    display: flex;
    border: 1px solid #DDDEE1;
  }

  .roomlist {
    flex: 2;
    border-right: 1px solid #DDDEE1;
    padding: 15px;
  }

  .checklist {
    flex: 1;
    padding: 15px;
  }

  li {
    margin: 0 10px 10px 0;
    width: 80px;
  }

</style>
